import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { businessInfo } from '../data/mock';

const smsNumber = businessInfo.phone.replace(/\./g, '');

export const TextUsButton = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setVisible(false);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => setVisible(true), 800);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleClick = () => {
    window.location.href = `sms:+1${smsNumber}`;
  };

  return (
    <button
      onClick={handleClick}
      data-testid="text-us-btn"
      className={`fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-amber-500 hover:bg-amber-400 text-black shadow-lg shadow-amber-500/30 flex items-center justify-center transition-all duration-300 hover:scale-105 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-white text-[10px] font-bold flex items-center justify-center border-2 border-black">
        1
      </span>
    </button>
  );
};
